import NovaSolicitacaoPopup from '../NovaSolicitacaoPopup';
import { TiposSolicitacao } from '@/assets/ts/controller/SolicitacaoController';
import Util from '@tekvue/assets/utils/Util';
import Field from '@tekvue/assets/interfaces/Field';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { INovaSolicitacao } from '../interfaces';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';

@Component({
  name: 'NovaSolicitacaoEstruturaGerencial',
})
export default class NovaSolicitacaoEstruturaGerencial extends Vue implements INovaSolicitacao {
  // #region [ DATA ]
  TP_SOLICITACAO = TiposSolicitacao.TP_SOLI_MOVIM_GERENCIAL;

  main: NovaSolicitacaoPopup | null = null;

  public get fields(): Field[] {
    return this.main ? [
      {
        name: 'DSHISTORICO',
        label: 'Histórico',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'NRTPMOVTRANSFM_HIST',
        label: 'Transferência',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTPMOVTRANSFH',
        valueField: 'NRTPMOVTRANSFM',
        items: this.main.transferencias,
        readonly: true
      },
      {
        name: 'NRMOTIVOTRANSF_HIST',
        label: 'Motivo de Transferência',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMMOTIVOTRANSF',
        valueField: 'NRMOTIVOTRANSF',
        items: this.main.motivosTransferencia,
        readonly: true,
      },
      {
        name: 'NRESTRUTURAM_GEREN_HIST',
        label: 'Estrutura Gerencial',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.main.estruturasGerenciais,
        readonly: true
      },
      {
        name: 'NRESCALATRABM_HIST',
        label: 'Escala de Trabalho',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESCALATRABM',
        valueField: 'NRESCALATRABM',
        items: this.main.escalas,
        readonly: true,
      },
      {
        name: 'NRTURNO_HIST',
        label: 'Turno',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRDSTURNO',
        valueField: 'NRTURNO',
        items: this.main.turnos_hist,
        readonly: true,
      },
      {
        name: 'VRSALARIOATUAL_HIST',
        label: 'Salário Atual',
        type: 'text',
        size: 6,
        readonly: true,
      },
      {
        name: 'IDTPSALARIO_HIST',
        label: 'Tipo de Salário',
        valueField: 'IDTPSALARIO',
        descriptionField: 'DSTPSALARIO',
        type: 'autocomplete',
        size: 6,
        readonly: true,
        items: [
          {
            IDTPSALARIO: 'MENSAL',
            DSTPSALARIO: 'Mensal',
          },
          {
            IDTPSALARIO: 'QUINZENAL',
            DSTPSALARIO: 'Quinzenal',
          },
          {
            IDTPSALARIO: 'SEMANAL',
            DSTPSALARIO: 'Semanal',
          },
          {
            IDTPSALARIO: 'DIARIO',
            DSTPSALARIO: 'Diário',
          },
          {
            IDTPSALARIO: 'HORA',
            DSTPSALARIO: 'Hora',
          },
          {
            IDTPSALARIO: 'TAREFA',
            DSTPSALARIO: 'Tarefa',
          },
        ],
      },
      {
        name: 'NRTIPOALTERA_HIST',
        label: 'Tipo de Alteração',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRTIPOALTERA',
        descriptionField: 'NMTIPOALTERA',
        items: this.main.tiposAlteraSal,
        readonly: true,
      },
      {
        name: 'DTADMISSAOVINC',
        label: 'Data de Admissão',
        size: 6,
        type: 'date',
        readonly: true,
      },
      {
        name: 'DSHIST',
        label: 'Novas informações',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'DTINIMOVIMENT',
        label: 'Início da Movimentação',
        type: 'date',
        month: true,
        size: 6,
        required: true,
        onInput: () => {
          this.main.validaDataAnteriorCompetencia('DTINIMOVIMENT');
        },        
        minDate: this.main.minDtInitMovimentMovimentacao,
        maxDate: this.main.maxDtInitMovimentMovimentacao,
        hint: 'Obs.: deve ser posterior à data de admissão do vínculo.',
        persistentHint: true,
      },
      {
        name: 'NRTIPOTRANSFER',
        label: 'Tipo de Transferência',
        type: 'select',
        size: 6,
        required: true,
        descriptionField: 'NMTIPOTRANSFER',
        valueField: 'NRTIPOTRANSFER',
        items: this.main.tiposTransferencia,
        readonly: true
      },
      {
        name: 'NRTPMOVTRANSFM',
        label: 'Transferência',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMTPMOVTRANSFH',
        valueField: 'NRTPMOVTRANSFM',
        items: this.main.transferencias,
        readonly: true
      },
      {
        name: 'NRMOTIVOTRANSF',
        label: 'Motivo de Transferência',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMMOTIVOTRANSF',
        valueField: 'NRMOTIVOTRANSF',
        items: this.main.motivosTransferencia,
      },
      {
        name: 'NRESTRUTURAM',
        label: 'Estrutura',
        type: 'autocomplete',
        size: 12,
        required: true,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.main.estruturasGerenciais,
      },
      {
        name: 'DTINIESCALA',
        label: 'Início da Escala',
        type: 'date',
        size: 6,
        required: this.main.isSoliEscalaRequired,
        onInput: () => this.main.validaDataAnteriorCompetencia('DTINIESCALA') && this.main.getTurnoParOuImpar(),
        month: true,
        minDate: this.main.getIntervaloDataRegra('min'),
        maxDate: this.main.getIntervaloDataRegra('max'),
      },
      {
        name: 'NRESCALATRABM',
        label: 'Escala de Trabalho',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESCALATRABM',
        valueField: 'NRESCALATRABM',
        required: this.main.isSoliEscalaRequired,
        items: this.main.escalas,
      },
      {
        name: 'CDTIPODIATRABALHO',
        label: 'Turno par ou ímpar',
        type: 'radio',
        valueField: 'value',
        outData: {
          DSTIPODIATRABALHO: 'label',
        },
        items: [
          {
            label: 'Trabalho em dia ímpar',
            value: 'I',
          },
          {
            label: 'Trabalho em dia par',
            value: 'P',
          },
        ],
        size: 6,
        isVisible: this.main.isEscala12x36,
        required: this.main.isEscala12x36,
        onInput: this.main.getTurnoParOuImpar
      },
      {
        name: 'NRTURNO',
        label: 'Turno',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRDSTURNO',
        valueField: 'NRTURNO',
        required: this.main.isSoliEscalaRequired,
        items: this.main.turnos,
        readonly: !this.main.row.NRESCALATRABM || this.main.isEscala12x36,
      }
    ] : [];
  }

  // #region [ WATCHERS ]
  @Watch('fields')
  private fieldsOnChange() {
    this.main.injectFields(this);
  }

  // #region [ ACTIONS ]
  public onAdvance(): void | Promise<void> {
    this.setTransferenciaGerenFields();
  };

  public get onSaveValidation() {
    return this.main.onSaveTransferenciaValidation;
  }

  public get afterAdvance() {
    return this.main.afterAdvanceActionHistoric;
  }

  // #region [ METHODS ]
  private async setTransferenciaGerenFields() {
    if(this.main.isEdit) {
      this.main.preencherCamposEdit();
    } else {
      await this.main.vinculoDemitidoOuAfastado();
      this.main.row.NRTIPOTRANSFER = '2';
      this.main.row.NRTPMOVTRANSFM = '12';
      this.main.row.NROCORRENCIA = 1;
    }

    this.main.isEscala12x36 = false;

    this.main.loading = true;
    try {
      const [previouMovim, previousEscala] = await Promise.all([
        NovaSolicitacaoController.getDadosPreviosSolicitacao(this.main.row.NRVINCULOM, 2),
        NovaSolicitacaoController.getDadosPreviosSolicitacao(this.main.row.NRVINCULOM, 14),
        this.main.loadTiposTransferencia(),
        this.main.loadTransferencias(),
        this.main.loadMotivosTransferencia(),
        this.main.loadEstruturasGerenciais(),
        this.main.loadEscalas(),
        this.main.loadTipoAlteraSal(),
        this.main.loadModalidadeSal(),
        this.main.loadUltimoSalario()
      ]);


      await this.main.setDefaultRowEscala(previousEscala, this.main.row);
      this.setDefaultRowTransferenciaGeren(previouMovim.GERENCIAL);
      this.main.setDefaultRowSalario();

      const defaultRowTransferenciaCopy = Util.deepCopy(this.main.defaultRowTransferenciaGeren);
      const defaultRowSalarioCopy = Util.deepCopy(this.main.defaultRowSalario);
      const defaultRowEscalaCopy = Util.deepCopy(this.main.defaultRowEscala);

      this.main.row = {...this.main.row, ...defaultRowTransferenciaCopy, ...defaultRowSalarioCopy, ...defaultRowEscalaCopy};

    } finally {
      this.main.loading = false;
    }
  }

  private setDefaultRowTransferenciaGeren (dataPrevGeren: any) {
    if(dataPrevGeren) {
      this.main.defaultRowTransferenciaGeren.NRTPMOVTRANSFM_HIST = dataPrevGeren.NRTPMOVTRANSFM;
      this.main.defaultRowTransferenciaGeren.NRESTRUTURAM_GEREN_HIST = dataPrevGeren.NRESTRUTURAM;
      this.main.defaultRowTransferenciaGeren.NRMOTIVOTRANSF_HIST = dataPrevGeren.NRMOTIVOTRANSF;
    }
  }
}